<template>
    <div class='content'>
        <div class="con-1">
            <div  :class="$i18n.locale + '_con-2'">{{ $t('content108') }}</div>
            <div :class="$i18n.locale + '_con-3'" >
                {{ $t('content109') }}</div>
            <!-- <div class="btn-box">
                <div class="btn-blue">预约演示</div>
                <div class="btn-we">参观一下</div>
            </div> -->
            <img :src="$i18n.locale == 'zh' ? require('@/assets/yongjin_banner@2x.png'):require('@/assets/en_yongjin_banner@2x.png')" class="con-3-img" alt="">
        </div>

        <div class="con-4">
            <div class="con-5">
                <div class="con-6">{{ $t('content110') }}</div>
                <div class="con-7">
                    {{ $t('content111') }}
                </div>
                <div class="con-8">
                    <img src="@/assets/Slice 25@2x.png" class="con-8-img" alt="">
                    <div class="con-9">{{ $t('content112') }}</div>
                </div>
                <div class="con-10">
                    <img src="@/assets/Slice 25@2x.png" class="con-8-img" alt="">
                    <div class="con-9">{{ $t('content113') }}</div>
                </div>
                <div class="con-10">
                    <img src="@/assets/Slice 25@2x.png" class="con-8-img" alt="">
                    <div class="con-9">
                         {{ $t('content114') }}</div>
                </div>
            </div>
            <div class="con-11">
                <img :src="$i18n.locale == 'zh' ? require('@/assets/wuguojie_img@2x.png'):require('@/assets/en_wuguojie_img@2x.png')" class="con-11-img" alt="">
            </div>
        </div>

        <div class="con-4">
            <div :class="$i18n.locale + '_con-12'">
                <img :src="$i18n.locale == 'zh' ? require('@/assets/Slice 30@2x.png'):require('@/assets/en_Slice 30@2x.png')" class="con-12-img" alt="">
            </div>
            
            <div :class="$i18n.locale + '_con-13'">
                <div class="con-14">{{ $t('content115') }}</div>
                <div class="con-8">

                    <div class="con-9-txt">
                        {{ $t('content116') }}</div>
                </div>
                <div class="con-15">
                    <img src="@/assets/Slice 25@2x.png" class="con-8-img" alt="">
                    <div class="con-9">{{ $t('content117') }}</div>
                </div>
                <div class="con-15">
                    <img src="@/assets/Slice 25@2x.png" class="con-8-img" alt="">
                    <div class="con-9">{{ $t('content118') }}</div>
                </div>
                <div class="con-15">
                    <img src="@/assets/Slice 25@2x.png" class="con-8-img" alt="">
                    <div class="con-9">{{ $t('content119') }}</div>
                </div>
                <div class="con-15">
                    <img src="@/assets/Slice 25@2x.png" class="con-8-img" alt="">
                    <div class="con-9">{{ $t('content120') }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
//import

export default {
    name: 'index_1',
    components: {

    },
    data() {
        return {

        };
    },
    computed: {

    },
    watch: {},
    methods: {

    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
}
</script>
<style scoped>
.con-1 {
    position: relative;
}

.en_con-2 {
    font-size: 36px;
    color: #333;
    position: absolute;
    top: 237px;
    left: 360px;
    width:550px
}

.zh_con-2 {
    font-size: 36px;
    color: #333;
    position: absolute;
    top: 237px;
    left: 360px;
}

.zh_con-3 {
    width: 484px;
    font-size: 22px;
    color: #666666;
    position: absolute;
    left: 360px;
    top: 306px;
    line-height: 32px;
}

.en_con-3 {
    width: 484px;
    font-size: 22px;
    color: #666666;
    position: absolute;
    left: 360px;
    top: 400px;
    line-height: 32px;
}

.con-3-img {
    width: 100%;
    height: 750px;
}

.btn-box {
    margin-top: 58px;
    text-align: center;
    display: flex;
    justify-content: center;
    margin-bottom: 49px;
    position: absolute;
    top: 435px;
    left: 360px;
}


.con-15 {
    display: flex;
    align-items: center;
    margin-top: 20px;
}

.con-5 {
    width: 473px;
    margin-left: 361px;
    margin-top: 206px;
}

.con-6 {
    font-size: 36px;
    color: #333333;
    margin-bottom: 34px;
    font-weight: 600
}

.zh_con-12 {
    margin-left: 196px;
}
.en_con-12 {
    margin-left: 140px;
    margin-top:80px
}

.con-12-img {
    width: 820px;
    height: 720px;
}

.zh_con-13 {
    margin-top: 149px;
}

.en_con-13 {
    margin-top: 149px;
    width:700px
}
.con-14 {
    font-size: 36px;
    color: #333333;
    margin-bottom: 27px;
    width: 544px;
    font-weight: 600
}

.con-8 {
    display: flex;
    align-items: center;
}

.con-8-img {
    width: 18px;
    height: 18px;
}

.btn-blue {
    width: 132px;
    height: 44px;
    font-size: 18px;
    background-color: #4873FF;
    color: #fff;
    border-radius: 5px;
    line-height: 44px;
    text-align: center;
    margin-right: 12px;
  cursor: pointer;

}

.con-4 {
    display: flex;
}

.con-7 {
    font-size: 22px;
    color: #666666;
    margin-bottom: 32px;
    line-height: 32px;
}

.con-10 {
    display: flex;
    align-items: center;
    margin-top: 20px;
}

.con-11 {
    width: 850px;
    height: 700px;
    margin-top: 4px;
}

.con-11-img {
    width: 100%;
    height: 100%;
}

.btn-we {
    width: 132px;
    height: 44px;
    font-size: 18px;
    background-color: #fff;
    color: #4873FF;
    border-radius: 5px;
    line-height: 44px;
    text-align: center;
    border: 1px solid #4873FF;
    margin-left: 12px;
  cursor: pointer;



}

.con-9 {
    font-size: 20px;
    color: #333333;
    margin-left: 12px;
}

.con-9-txt {
    font-size: 22px;
    color: #666666;
    line-height: 32px;
    width: 555px;
}
</style>